export const MODERATOR = 'moderator';
export const ADMINISTRATOR = 'administrator';
export const SELLER = 'seller';
export const PARTNER = 'partner';
